package core.enums

enum class EEnvironmentVariables(val mVariableName: String, val mDefault: String) {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    HOST("HOST_URL", "localhost"),

    PRODUCT_FLAVOR("PRODUCT_FLAVOR", "DEV")

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}